import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackIntegrationPageEvent = createAnalyticsTracker(
  'integrationPageVNext',
);
